
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import GetInvolved from "../pages/get-involved/page";
import AnnualReport from "../pages/about/annual-report/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/get-involved",
    element: <GetInvolved />,
  },
  {
    path: "/about/annual-report",
    element: <AnnualReport />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;